import { render, staticRenderFns } from "./sourdialog.vue?vue&type=template&id=5977ef85&scoped=true"
import script from "./sourdialog.vue?vue&type=script&lang=js"
export * from "./sourdialog.vue?vue&type=script&lang=js"
import style0 from "./sourdialog.vue?vue&type=style&index=0&id=5977ef85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5977ef85",
  null
  
)

export default component.exports